import Repository from "./Repository";

const resource = "";

export default {
  /**
   * 個別観測所・観測所詳細画面 河川予警報情報取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param isSingle [true:緊急度が一番高い１レコードのみ取得 / false:すべてのレコードを取得]
   */
  getObsRiverWarnInfo(ofcCd, itmkndCd, obsCd, isSingle) {
    let param = "/" + ofcCd + "/" + itmkndCd + "/" + obsCd + "/" + isSingle;
    return Repository.get(`${resource}/rw/tmRw` + param);
  },
};
